import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/edit.svg'
import _imports_2 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 2,
  class: "badge bg-light text-dark product-count-badge"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 4,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["title", "onClick"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_13 = { class: "fs-13 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.adjustments,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.paginationConfig,
        locale: _ctx.tableLocale,
        scroll: { x: 980 },
        class: "text-nowrap align-middle adjustment-table"
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column && column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(record.created_at)), 1)
              ], 64))
            : (column && column.key === 'warehouse_name')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  title: record.warehouse_name
                }, _toDisplayString(record.warehouse_name || _ctx.t("adjustment_page.not_available_short")), 9, _hoisted_3))
              : (column && column.key === 'items')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t("adjustment_page.products_count", { count: record.items ? record.items.length : 0 })), 1))
                : (column && column.key === 'note')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: "note-text",
                      title: record.note || _ctx.t('adjustment_page.not_available_short')
                    }, _toDisplayString(record.note || _ctx.t("adjustment_page.not_available_short")), 9, _hoisted_5))
                  : (column && column.key === 'actions')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("button", {
                          class: "btn p-0 border-0 action-icon-btn",
                          title: _ctx.t('adjustment_page.view'),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#adjustmentDetailsModal",
                          onClick: ($event: any) => (_ctx.$emit('view-details', record))
                        }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: _ctx.t('adjustment_page.view'),
                            style: {"width":"14px"}
                          }, null, 8, _hoisted_8)
                        ], 8, _hoisted_7),
                        _createVNode(_component_router_link, {
                          to: `/edit-adjustment/${record.id}`,
                          title: _ctx.t('adjustment_page.edit'),
                          class: "btn p-0 border-0 action-icon-btn"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: _ctx.t('adjustment_page.edit'),
                              style: {"width":"14px"}
                            }, null, 8, _hoisted_9)
                          ]),
                          _: 1
                        }, 8, ["to", "title"]),
                        _createElementVNode("button", {
                          class: "btn p-0 border-0 action-icon-btn",
                          title: _ctx.t('adjustment_page.delete'),
                          onClick: ($event: any) => (_ctx.$emit('delete-adjustment', record))
                        }, [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: _ctx.t('adjustment_page.delete'),
                            style: {"width":"14px"}
                          }, null, 8, _hoisted_11)
                        ], 8, _hoisted_10)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(_toDisplayString(_ctx.getCellText(text)), 1)
                      ], 64))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "locale"]),
      (!_ctx.loading && _ctx.adjustments.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t("adjustment_page.showing_adjustments", { count: _ctx.adjustments.length })), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}